import '../css/home.css';
import '../css/wa.css';
import '../styles/HeadlineCarousel.css';
import '../css/mb.css';
import React, { useEffect, useState } from 'react';
import axios from "axios"
import '../css/news.css';

import NewsHeadline from '../components/newsHeadline';
import { IoTimeOutline, IoHeart } from "react-icons/io5";
import { FaCommentAlt, FaUser, FaEye, FaCheckCircle } from "react-icons/fa";

const News = () => {
  const [hotNews, setHotNews] = useState([]);
  const [news, setNews] = useState([]);
  const [tradingSearch, setTradingSearch] = useState([]);
  const [tradingTag, setTradingTag] = useState([]);



  useEffect(() => {
    const getHotNews = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/hot/byhead`, { head: 'NEWS' });
          setHotNews(data.results);
          
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    const getNews = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/getnews`, { head: 'NEWS' });
          setNews(data.results);
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    const getTrading = async () => {
      try {
          const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/gettrading`, {});
          setTradingSearch(data.search);
          console.log(data)
      } catch (error) {
          console.error("Error fetching chat data:", error.response || error);
      }
    };
    getTrading();
    getHotNews();
    getNews();
  }, []); // 컴포넌트가 처음 렌더링될 때 실행

    
  const getRandomPastelColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 70%, 90%)`;
  };

  const maxCount = Math.max(...tradingSearch.map((k) => k.count));
  const minSize = 10;
  const maxSize = 30;

  return (
    <>
      <div className='news-ct'>
        <div className='flex-2'>
          <div className='hm-headline-ct'>
              <NewsHeadline />
          </div>

          <div className='news-flex'>
            <div className="wa-card">
              <div className='wa-card-title'>인기 뉴스</div>
                <div className="news-1">
                  {hotNews.map((article) => (
                        <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                            <div className='cm-view'><FaEye />{article.view}</div>
                            {article.previewImage ? 
                              <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                            : null }
                            <div className="cm-card-list-item-content">
                                <div className="cm-card-list-item-title">{article.title}</div>
                                <div className="cm-card-list-item-meta">
                                    <IoTimeOutline />
                                    <span className="meta-time">{article.date}</span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-likes">
                                        <IoHeart />
                                        {article.like}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-comments">
                                        <FaCommentAlt className='icon-smaller' />
                                        {article.commentCount}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-time">
                                      <FaUser />
                                      {article.username} 
                                      {article.expert === '1' && <FaCheckCircle className='check' />}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>  
            <div className="wa-card">
              <div className='wa-card-title'>뉴스 최신글</div>
                <div className="news-1">
                  {news.map((article) => (
                        <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                            <div className='cm-view'><FaEye />{article.view}</div>
                            
                            {article.previewImage ? 
                              <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                            : null }
                            <div className="cm-card-list-item-content">
                                <div className="cm-card-list-item-title">{article.title}</div>
                                <div className="cm-card-list-item-meta">
                                    <IoTimeOutline />
                                    <span className="meta-time">{article.date}</span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-likes">
                                        <IoHeart />
                                        {article.like}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-comments">
                                        <FaCommentAlt className='icon-smaller' />
                                        {article.commentCount}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-time">
                                      <FaUser />
                                      {article.username} 
                                      {article.expert === '1' && <FaCheckCircle className='check' />}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>  
          </div>
          

        </div>
        <div className='flex-1'>
          <div className='wa-card'>
          </div>
          <div className='wa-card'>
            <div className='wa-card-title'>실시간 인기 검색어</div>
            <div className="wa-trading-keywords">
              {tradingSearch.map((keyword, index) => {
                const fontSize =
                  minSize +
                  ((keyword.count / maxCount) * (maxSize - minSize)); // 비율에 따른 크기 조절
                return (
                  <span
                    key={index}
                    onClick={() => window.location.href = `/search/${keyword.keyword}`}
                    className="keyword"
                    style={{
                      fontSize: `${fontSize}px`,
                      backgroundColor: getRandomPastelColor(),
                      borderRadius: "8px",
                      margin: "5px",
                      display: "inline-block",
                    }}
                  >
                    {keyword.keyword} 
                    <span className='small'>{keyword.count}번 검색</span>
                  </span>
                );
              })}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default News;